import styled, { css } from 'styled-components';

import { InputContainer } from '@components/Input';

export const Content = styled.div`
  margin: 40px 0 0;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    display: flex;
    flex-direction: column;
    svg {
      align-self: center;
    }
    row-gap: 20px;
    margin-top: 0px;
  }
`;

export const Section = styled.section`
  margin: 32px 0 40px;
  display: flex;
  button {
    height: unset;
    width: 148px;
    font-weight: bold;
  }
  column-gap: 20px;
  ${InputContainer} {
    flex: 1;
  }
  @media only screen and (max-width: 650px) {
    flex-direction: column;
    row-gap: 20px;
    margin: 0px 0px;
    &:last-child {
      margin-bottom: 20px;
      margin-top: 20px;
    }
    ${InputContainer} {
      height: 68px;
      flex: unset;
    }
    button {
      height: 68px;
      width: 100%;
    }
  }
`;
export const Paragraph = styled.p`
  font-size: 14px;
  line-height: 1.57;
  margin: 0;
  color: ${(p) => p.theme.palette.darkGrey};
  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    text-align: center;
  }
`;

export const responsiveness = css`
  @media only screen and (max-width: 360px) {
    flex-direction: column;
  }
`;

export const Label = styled.span`
  font-weight: 600;
`;

export const Span = styled.span`
  &:before {
    content: ' ';
    white-space: pre;
  }
  @media only screen and (max-width: 360px) {
    line-height: 1.57;
    &::before {
      content: '';
    }
  }
`;
